<template>
  <NavBar v-if="showSidebar" />
  <div id="view" :class="{ collapsed, 'no-sidebar': !showSidebar }" class="content">
    <router-view />
  </div>
  <sidebar-menu
    v-if="showSidebar"
    class="sidebar"
    :menu="menu"
    :width="'200px'"
    :widthCollapsed="'50px'"
    :collapsed="collapsed"
    @update:collapsed="onCollapse"
  />
</template>
<script>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { $mqtt } from 'vue-paho-mqtt';
import { useI18n } from 'vue-i18n';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { getPermission } from './User';
import developerMenu from './menu/DeveloperMenu';
import managerMenu from './menu/ManagerMenu';
import userMenu from './menu/UserMenu';
import observerMenu from './menu/ObserverMenu';
import NavBar from './components/NavBar.vue';

export default {
  components: {
    NavBar,
  },
  data() {
    return {
      collapsed: true,
    };
  },
  setup() {
    const { t, locale } = useI18n();
    const route = useRoute();
    const permission = ref(getPermission());
    const menu = ref([]);
    const translateMenu = (menuData) => menuData.map((item) => {
      const newItem = { ...item };
      if (item.titleKey) {
        newItem.title = t(item.titleKey);
      }
      if (item.child) {
        newItem.child = translateMenu(item.child);
      }
      return newItem;
    });

    // eslint-disable-next-line no-unused-vars
    const updateMenu = (newPermission) => {
      switch (newPermission) {
        case 1:
          menu.value = developerMenu;
          break;
        case 2:
          menu.value = managerMenu;
          break;
        case 3:
          menu.value = userMenu;
          break;
        default:
          menu.value = observerMenu;
      }
      menu.value = translateMenu(menu.value);
    };

    const onMessage = (msg, type) => {
      toast(msg, {
        theme: 'colored',
        type,
        dangerouslyHTMLString: true,
      });
      console.log('test');
    };

    updateMenu(permission.value);
    watch(
      () => route.path,
      () => {
        const newPermission = getPermission();
        permission.value = newPermission;
        updateMenu(newPermission);
      },
    );
    watch(locale, () => {
      updateMenu(permission.value);
    });
    onMounted(async () => {
      $mqtt.connect({
        onConnect: () => {
          $mqtt.subscribe(
            'UTB/cloud/info',
            (message) => {
              onMessage(message, 'info');
            },
            false,
          );
          $mqtt.subscribe(
            'UTB/cloud/alarm',
            (message) => {
              onMessage(message, 'error');
            },
            false,
          );
        },
        onFailure: () => {
          console.log('Mqtt connection failed');
        },
      });
    });
    return {
      menu,
      onMessage,
    };
  },
  computed: {
    showSidebar() {
      return this.$route.path !== '/login';
    },
  },
  methods: {
    onCollapse(c) {
      this.collapsed = c;
    },
  },
};
</script>
<style>
body {
  background-color: #f1f5fb;
}

#view {
  padding-left: 200px;
}

.content {
  padding-top: 40px;
}

#view.collapsed {
  padding-left: 50px;
}

.no-sidebar {
  padding-left: 0px;
}

.v-sidebar-menu {
  --vsm-item-font-size: 16px;
  --vsm-item-line-height: 30px;
  --vsm-icon-height: 30px;
  --vsm-icon-width: 20px;
}
#trackinfo {
  padding: 20px;
  padding-top: 0px;
  text-align: left;
  background: white;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.list-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}

.btn {
  margin-inline: 5px;
}

.btn-mr {
  margin-right: 20px;
}

.input-group-add {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: space-between;
}

.label-add {
  flex: 0.2;
  text-align: left;
  margin-right: 10px;
  font-size: 20px;
}

.input-add {
  flex: 1;
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px;
  font-size: 20px;
  width: 220px;
}

.button-submit {
  background-color: #4285f4;
  color: white;
  width: 100%;
  height: 45px;
  border: 0;
  font-size: 16px;
  border-radius: 5px;
  margin-top: 20px;
}
</style>
